export default __webpack_public_path__ + "static/media/Ndtv 2.5da2f0f4.png";